import { EntrepreneurForm } from '../../Forms/EntrepreneurForm/EntrepreneurForm';
import { AccountantForm } from '../../Forms/AccountantForm/AccountantForm';
import { BankAccountNameEditForm } from '../../Forms/BankAccountEdit/BankAccountNameEditForm';
import { BankAccountDeleteForm } from '../../Forms/BankAccountDeleteForm/BankAccountDeleteForm';
import { FileDeleteForm } from '../../Forms/FileDeleteForm/FileDeleteForm';
import { SzamlazzHuPanel } from '../../OuterApi/SzamlazzHu/SzamlazzHuPanel';
import { AddAccessTokenForm } from '../../Forms/AddAccessTokenForm/AddAccessTokenForm';
import { KeyAndSecretPanel } from '../../KeyAndSecret/KeyAndSecretPanel';
import { RevokeTokenForm } from '../../Forms/RevokeTokenForm/RevokeTokenForm';
import { AccountantDeleteForm } from '../../Forms/AccountantDeleteForm/AccountantDeleteForm';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import * as React from 'react';
import { OuterApiPanel } from '../../OuterApi/OuterApiPanel/OuterApiPanel';
import { MODAL_STATE } from '../../../Model/Enums';
import { clearSecretBag } from '../../../Store/paramsBagSlice';
import { OuterApiRevokeForm } from '../../Forms/OuterApiRevokeForm/OuterApiRevokeForm';
import { modalStateSelector } from '../../../Store/layoutSlice';
import { BankAccountMoveForm } from '../../Forms/BankAccountMoveForm/BankAccountMoveForm';

type ModalState = {
  [key in MODAL_STATE]?: {
    header: string;
    content: JSX.Element;
    size?: string;
    callback?: Function;
  };
};

export const useModalState = () => {
  const modalState = useAppSelector(modalStateSelector);
  const dispatch = useAppDispatch();

  const state: ModalState = {
    [MODAL_STATE.NEW_COMPANY_FIRST_STEP]: {
      header: 'Új cég létrehozása',
      content: <EntrepreneurForm isUpdate={false} />,
    },
    [MODAL_STATE.EDIT_COMPANY_FIRST_STEP]: {
      header: 'Cégadatok szerkesztése',
      content: <EntrepreneurForm isUpdate={true} />,
    },
    [MODAL_STATE.BANK_ACCOUNT_NAME_EDIT]: {
      header: 'A bankszámla szerkesztése',
      content: <BankAccountNameEditForm />,
    },
    [MODAL_STATE.BANK_ACCOUNT_DELETE]: {
      header: 'A bankszámla törlése',
      content: <BankAccountDeleteForm />,
    },
    [MODAL_STATE.FILE_DELETE]: {
      header: 'A fájl törlése ',
      content: <FileDeleteForm />,
    },
    [MODAL_STATE.API_CONNECT]: {
      header: 'API kapcsolat beállítása banki adatok fogadásához',
      content: <OuterApiPanel />,
    },
    [MODAL_STATE.SZAMLAZZHU]: {
      header: 'Számlázz.hu Api beállítás ',
      content: <SzamlazzHuPanel />,
      size: 'modal-xl',
    },
    [MODAL_STATE.API_CONNECT_REVOKE]: {
      header: 'API intergráció visszavonása',
      content: <OuterApiRevokeForm />,
    },
    [MODAL_STATE.NEW_ACCESS_TOKEN]: {
      header: 'Hozzáférési kulcs létrehozása',
      content: <AddAccessTokenForm />,
    },
    [MODAL_STATE.REVEAL_SECRET]: {
      header: 'Hozzáférési adatok',
      content: <KeyAndSecretPanel />,
      size: 'modal-xl',
      callback: () => dispatch(clearSecretBag()),
    },
    [MODAL_STATE.REVOKE_TOKEN]: {
      header: 'Hozzáférési kulcs visszavonása',
      content: <RevokeTokenForm />,
    },
    [MODAL_STATE.ACCOUNTANT_DELETE]: {
      header: 'A könyvelő törlése',
      content: <AccountantDeleteForm />,
    },
    [MODAL_STATE.NEW_ACCOUNTANT]: {
      header: 'Új könyvelő regisztrációja',
      content: <AccountantForm />,
    },
    [MODAL_STATE.MOVE_TO_ANOTHER_COMPANY]: {
      header: 'Bankszámla áthelyezése',
      content: <BankAccountMoveForm />,
    },
  };

  return { state: state[modalState] };
};
